import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SignOffEmployeesModule } from '@data-terminal/feature-dialogs/components/sign-off-employees/sign-off-employees.component';
import { SignOffOperationsModule } from '@data-terminal/feature-dialogs/components/sign-off-operations/sign-off-operations.component';
import { SignOffSummaryModule } from '@data-terminal/feature-dialogs/components/sign-off-summary/sign-off-summary.component';
import { SignOffTimeTransferComponent } from '@data-terminal/feature-dialogs/components/sign-off-time-transfer/sign-off-time-transfer.component';
import { SignOffWorkstationsModule } from '@data-terminal/feature-dialogs/components/sign-off-workstations/sign-off-workstations.component';
import { EndShiftProcessService } from '@data-terminal/feature-dialogs/services/processes/end-shift-process.service';
import { SignOffDialogConfig, SignOffDialogStep } from '@data-terminal/shared-models/dialogs/sign-off-dialog';
import { SignOffMachine } from '@data-terminal/shared-models/machine';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, shareReplay, tap } from 'rxjs';

import { AbstractSignOffDialogComponent } from '../abstract-sign-off-dialog.component';

type EndShiftFormControls = {
    [SignOffDialogStep.OPERATIONS]: FormControl<boolean | null>;
    [SignOffDialogStep.TIME_TRANSFER]: FormControl<boolean | null>;
    [SignOffDialogStep.SUMMARY]: FormControl<boolean | null>;
};

@Component({
    selector: 'data-terminal-end-shift-dialog',
    templateUrl: './end-shift-dialog.component.html',
    styleUrls: ['../sign-off-dialog/sign-off-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [CdkStepper],
    imports: [
        MatStepperModule,
        MatToolbarModule,
        MatButtonModule,
        CommonModule,
        SignOffWorkstationsModule,
        SignOffEmployeesModule,
        SignOffOperationsModule,
        SignOffSummaryModule,
        SignOffTimeTransferComponent,
        TranslateModule,
        MatIconModule,
        CdkStepperModule,
    ],
})
export class EndShiftDialogComponent extends AbstractSignOffDialogComponent<EndShiftFormControls> {
    private readonly endShiftProcessService = inject(EndShiftProcessService);

    public machinesToSignOff$: Observable<SignOffMachine[]>;
    public config$: Observable<SignOffDialogConfig>;

    public dialogForm = new FormGroup<EndShiftFormControls>({
        [SignOffDialogStep.OPERATIONS]: new FormControl<boolean | null>(null, Validators.required),
        [SignOffDialogStep.TIME_TRANSFER]: new FormControl<boolean | null>(null, Validators.required),
        [SignOffDialogStep.SUMMARY]: new FormControl<boolean | null>(null),
    });

    protected readonly finalActionText = 'END_SHIFT';

    constructor() {
        super();
        this.isActionButtonDisable = false;
        this.config$ = this.endShiftProcessService.getConfig().pipe(tap((data) => this.setButtonsByConfig(data)));
        this.machinesToSignOff$ = this.endShiftProcessService.getMachineToSignOff().pipe(shareReplay());
    }

    public onOperationStateChange(signOffMachines: SignOffMachine[]): void {
        this.endShiftProcessService.onOperationStateChange(signOffMachines);
    }
}
